export default "__VITE_ASSET__DP5$OUWO__"